<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <b-card no-body>
          <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
            <b-form  @submit.prevent="handleSubmit(admission_submit)" @reset.prevent="reset" >
              <b-row style="padding:10px">
                <b-col md="4">
                  <ValidationProvider name="Register No" vid="register_no" rules="required">
                    <b-form-group class="row" label-cols-sm="6" label-for="register_no" slot-scope="{ valid, errors }">
                      <template v-slot:label>
                        {{$t('social_service.register_no')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                      type="text"
                      required
                      id="pay_grade"
                      v-model="patient_form.hos_reg_no"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-input>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                    <ValidationProvider name="Department" vid="department" rules="required|min_value:1">
                      <b-form-group
                        class="row"
                        label-cols-sm="6"
                        label-for="department"
                        slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{ $t('hospital_information.dept')}} <span class="text-danger">*</span>
                        </template>
                          <b-form-select
                          plain
                          v-model="patient_form.department_id"
                          id="department_id"
                          :options="departmentList"
                          :state="errors[0] ? false : (valid ? true : null)"
                        >
                        <template v-slot:first>
                            <b-form-select-option :value="-1">{{$t('globalTrans.select')}}</b-form-select-option>
                            <b-form-select-option :value="0">{{$t('globalTrans.other')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                    </b-col>
                    <b-col md="4">
                    <ValidationProvider name="Ward" vid="ward" rules="required|min_value:1">
                      <b-form-group
                        class="row"
                        label-cols-sm="6"
                        label-for="ward"
                        slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{ $t('hospital_information.ward')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                          type="text"
                          id="hos_ward_id"
                          v-model="patient_form.hos_ward_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                    </b-col>
                    <b-col md="4">
                    <ValidationProvider name="Bed No" vid="bed_no">
                      <b-form-group
                        class="row"
                        label-cols-sm="6"
                        label-for="bed_no"
                        slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{ $t('hospital_information.bed_no')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                          type="text"
                          id="hos_bed_id"
                          v-model="patient_form.hos_bed_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                    </b-col>
                <b-col md="4">
                  <ValidationProvider name="Disease Name/ Problem (Bn)" vid="patient_situation_bn" rules="required">
                    <b-form-group class="row" label-cols-sm="6" label-for="patient_situation_bn" slot-scope="{ valid, errors }">
                      <template v-slot:label>
                        {{$t('social_service.dises_name_bn')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                      type="text"
                      id="patient_situation_bn"
                      v-model="patient_form.patient_situation_bn"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-input>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                  <ValidationProvider name="Disease Name/ Problem (En)" vid="patient_situation" rules="required">
                    <b-form-group class="row" label-cols-sm="6" label-for="patient_situation" slot-scope="{ valid, errors }">
                      <template v-slot:label>
                        {{$t('social_service.dises_name_en')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                      type="text"
                      id="patient_situation"
                      v-model="patient_form.patient_situation"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-input>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                  <ValidationProvider name="Weight" vid="weight" rules="required">
                    <b-form-group class="row" label-cols-sm="6" label-for="weight" slot-scope="{ valid, errors }">
                      <template v-slot:label>
                        {{ $t('social_service.wight') }} <span class="text-danger">*</span>
                      </template>
                       <b-form-input
                      type="text"
                      id="weight"
                      v-model="patient_form.weight"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-input>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                  <ValidationProvider name="Blood Group (Bn)" vid="blood_group_bn" rules="required">
                    <b-form-group class="row" label-cols-sm="6" label-for="blood_group_bn" slot-scope="{ valid, errors }">
                      <template v-slot:label>
                        {{$t('social_service.blood_bn')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                      type="text"
                      id="blood_group_bn"
                      v-model="patient_form.blood_group_bn"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-input>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                  <ValidationProvider name="Blood Group (En)" vid="blood_group" rules="required">
                    <b-form-group class="row" label-cols-sm="6" label-for="blood_group" slot-scope="{ valid, errors }">
                      <template v-slot:label>
                        {{$t('social_service.blood_en')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                      type="text"
                      id="blood_group"
                      v-model="patient_form.blood_group"
                      :state="errors[0] ? false : (valid ? true : null)"
                      ></b-form-input>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
              </b-row>
               <!-- Relevent Document Upload | Title -->
               <template>
                <div style="font-size:18px; background-color: #005B5B;">
                    <h5 class="text-white text-center"> {{ $t('social_service.relevant_document_upload') }}
                    </h5>
                </div>
            </template>
              <!-- related documents -->
              <b-overlay :show="customAttachment.loader" rounded="sm">
                <b-row style="padding-top:10px">
                  <b-col md="4">
                    <ValidationProvider name="Related Document Name (En)" vid="related_document_bn" rules="">
                      <b-form-group class="row" label-cols-sm="6" label-for="related_document_bn" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.related_docu_bn')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        id="related_document_bn"
                        v-model="customAttachment.document_title_bn"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <b-col md="4">
                    <ValidationProvider name="Related Document Name (En)" vid="related_document" rules="">
                      <b-form-group class="row" label-cols-sm="6" label-for="related_document" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.related_docu_en')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        id="related_document"
                        v-model="customAttachment.document_title"
                        :state="errors[0] ? false : (valid ? true : null)"
                        >
                        </b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <b-col md="4">
                    <ValidationProvider name="Attachment" vid="attachment" rules="">
                      <b-form-group class="row" label-cols-sm="4" label-for="attachment" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.upload')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-file
                        id="attachment"
                        accept=".png, .jpg, .jpeg, .svg, .pdf, .doc, .docx, .tex, .txt, .rtf"
                        class="form-control"
                        v-model="customAttachment.attachment"
                        v-on:change="onFileChange"
                        :state="errors[0] ? false : (valid ? true : null)"
                        >
                        {{patient_form.attachment}}
                        </b-form-file>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <template v-if="admisson_other_info.related_documents.length > 0">
                  <b-row>
                    <b-col xl="12" lg="12" sm="12">
                      <iq-card>
                          <div style="font-size:18px; background-color: #005B5B;">
                              <h5 class="text-white text-center">
                                  {{ $t('social_service.docu') }}
                              </h5>
                          </div>
                      </iq-card>
                    </b-col>
                  </b-row>
                  <template v-for="(attachedFile, index) in admisson_other_info.related_documents">
                    <b-row :key="index">
                        <b-col cols="3">
                            <span style="color: #609513">
                              {{ attachedFile.document_title_bn}}
                            </span>
                        </b-col>
                        <b-col cols="3">
                            <span style="color: #609513">
                              {{ attachedFile.document_title }}
                            </span>
                        </b-col>
                        <b-col cols="4">
                          <!-- Different Download Link | From Temp -->
                          <a :href="hospitalServiceBaseUrl + 'download-attachment?file=' + attachedFile.file_name" target="_blank" v-if="attachedFile.id === 0">
                              {{ attachedFile.original_file_name }}
                              <i class="ri-download-cloud-line" ></i>
                          </a>

                          <!-- Different Download Link | From Storage -->
                          <a :href="hospitalServiceBaseUrl + 'download-attachment?file=' + attachedFile.attachment" target="_blank" v-if="attachedFile.id > 0">
                            {{ attachedFile.attachment.split('/').pop() }}
                            <i class="ri-download-cloud-line" ></i>
                          </a>
                        </b-col>
                        <b-col cols="2">
                          <!-- Different Delete | One deletes File from Temp -->
                          <b-button variant=" iq-bg-danger" size="sm" v-if="attachedFile.id === 0" @click="deleteUploadedFile(attachedFile.file_name)">
                            <i class="ri-delete-bin-line m-0"> </i>
                          </b-button>

                          <!-- Different Delete | Deletes DB Record & File -->
                          <b-button variant=" iq-bg-danger" size="sm" v-if="attachedFile.id > 0" @click="deleteUploadedFileFromDatabase(attachedFile)">
                            <i class="ri-delete-bin-line m-0"> </i>
                          </b-button>
                        </b-col>
                    </b-row>
                    <br :key="index + 999"/>
                  </template>
                </template>
              </b-overlay>
              <!-- comments start from here -->
              <template>
                <div style="font-size:18px; background-color: #005B5B;">
                    <h5 class="text-white text-center"> {{ $t('social_service.other_information') }}
                    </h5>
                </div>
            </template>
              <template v-slot:headerTitle>
                  <h4 class="card-title">{{ $t('social_service.health_measurment') }}</h4>
              </template>
              <b-table-simple bordered>
                <b-tbody>
                  <b-tr>
                    <b-td class="w-25">
                      {{$t('social_service.regular_checkup_en')}}
                    </b-td>
                    <b-td style="padding-left:20px">
                      <ValidationProvider name="regular" vid="regular" rules="required">
                            <b-form-group v-slot="{ regular }">
                              <b-form-radio v-model="admisson_other_info.regular" :aria-describedby="regular" name="regular" value="1">{{$t('social_service.yes')}}</b-form-radio>
                              <b-form-radio v-model="admisson_other_info.regular" :aria-describedby="regular" name="regular" value="2">{{$t('social_service.no')}}</b-form-radio>
                            </b-form-group>
                        </ValidationProvider>
                    </b-td>
                    <b-td style="padding-left:20px">
                      <ValidationProvider name="Regular Comment (En)" vid="regular_comment_bn" rules="required">
                          <b-form-group class="" label-for="regular_comment_bn" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_bn')}}
                            <b-form-textarea id="regular_comment_bn" v-model="admisson_other_info.regular_comment_bn"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                      <ValidationProvider name="Regular Comment (En)" vid="regular_comment" rules="required">
                          <b-form-group class="" label-for="regular_comment" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_en')}}
                            <b-form-textarea id="regular_comment" v-model="admisson_other_info.regular_comment"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                    </b-td>
                  </b-tr>
                  <!-- <b-tr>
                    <b-td class="w-25">
                      {{$t('social_service.regular_checkup_bn')}}
                    </b-td>
                    <b-td style="padding-left:20px">
                      <ValidationProvider name="Comment (En)" vid="name_en" rules="required">
                            <b-form-group>
                              <b-form-checkbox>Yes</b-form-checkbox>
                              <b-form-checkbox>No</b-form-checkbox>
                            </b-form-group>
                        </ValidationProvider>
                    </b-td>
                    <b-td style="padding-left:20px">
                      <ValidationProvider name="Comment (En)" vid="name_en" rules="required">
                          <b-form-group class="row" label-for="name_en" slot-scope="{ valid, errors }">
                            {{$t('social_service.comment')}}
                            <b-form-textarea id="name_en" v-model="admisson_other_info.name_en"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                      <ValidationProvider name="Comment (En)" vid="name_en" rules="required">
                          <b-form-group class="row" label-for="name_en" slot-scope="{ valid, errors }">
                            {{$t('social_service.comment')}}
                            <b-form-textarea id="name_en" v-model="admisson_other_info.name_en"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                    </b-td>
                  </b-tr> -->
                  <b-tr>
                    <b-td class="w-25">
                      {{$t('social_service.vaccination')}}
                    </b-td>
                    <b-td style="padding-left:20px">
                      <ValidationProvider name="Vaccination" vid="vaccination" rules="required">
                           <b-form-group v-slot="{ vaccination }">
                              <b-form-radio v-model="admisson_other_info.vaccination" :aria-describedby="vaccination" name="vaccination" value="1">{{$t('social_service.yes')}}</b-form-radio>
                              <b-form-radio v-model="admisson_other_info.vaccination" :aria-describedby="vaccination" name="vaccination" value="2">{{$t('social_service.no')}}</b-form-radio>
                            </b-form-group>
                        </ValidationProvider>
                    </b-td>
                    <b-td style="padding-left:20px">
                      <ValidationProvider name="Vaccination Comment (Bn)" vid="vaccination_comment_bn" rules="required">
                          <b-form-group class="" label-for="vaccination_comment_bn" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_bn')}}
                            <b-form-textarea id="vaccination_comment_bn" v-model="admisson_other_info.vaccination_comment_bn"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                      <ValidationProvider name="Vaccination Comment (En)" vid="vaccination_comment" rules="required">
                          <b-form-group class="" label-for="vaccination_comment" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_en')}}
                            <b-form-textarea id="vaccination_comment" v-model="admisson_other_info.vaccination_comment"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td class="w-25">
                      {{$t('social_service.food_all')}}
                    </b-td>
                    <b-td style="padding-left:20px">
                      <ValidationProvider name="Food" vid="food" rules="required">
                            <b-form-group v-slot="{ food }">
                              <b-form-radio v-model="admisson_other_info.food" :aria-describedby="food" name="food" value="1">{{$t('social_service.yes')}}</b-form-radio>
                              <b-form-radio v-model="admisson_other_info.food" :aria-describedby="food" name="food" value="2">{{$t('social_service.no')}}</b-form-radio>
                            </b-form-group>
                        </ValidationProvider>
                    </b-td>
                     <b-td style="padding-left:20px">
                      <ValidationProvider name="Food Comment (Bn)" vid="food_comment_bn" rules="required">
                          <b-form-group class="" label-for="food_comment_bn" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_bn')}}
                            <b-form-textarea id="food_comment_bn" v-model="admisson_other_info.food_comment_bn"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                      <ValidationProvider name="Food Comment (En)" vid="food_comment" rules="required">
                          <b-form-group class="" label-for="food_comment" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_en')}}
                            <b-form-textarea id="food_comment" v-model="admisson_other_info.food_comment"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td class="w-25">
                      {{$t('social_service.smoking')}}
                    </b-td>
                    <b-td style="padding-left:20px">
                      <ValidationProvider name="Smoking" vid="smoking" rules="required">
                            <b-form-group v-slot="{ smoking }">
                              <b-form-radio v-model="admisson_other_info.smoking" :aria-describedby="smoking" name="smoking" value="1">{{$t('social_service.yes')}}</b-form-radio>
                              <b-form-radio v-model="admisson_other_info.smoking" :aria-describedby="smoking" name="smoking" value="2">{{$t('social_service.no')}}</b-form-radio>
                            </b-form-group>
                        </ValidationProvider>
                    </b-td>
                     <b-td style="padding-left:20px">
                      <ValidationProvider name="Smoking Comment (Bn)" vid="smoking_comment_bn" rules="required">
                          <b-form-group class="" label-for="smoking_comment_bn" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_bn')}}
                            <b-form-textarea id="smoking_comment_bn" v-model="admisson_other_info.smoking_comment_bn"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                      <ValidationProvider name="Smoking Comment (En)" vid="smoking_comment" rules="required">
                          <b-form-group class="" label-for="smoking_comment" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_en')}}
                            <b-form-textarea id="smoking_comment" v-model="admisson_other_info.smoking_comment"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td class="w-25">
                      {{$t('social_service.phy_dis')}}
                    </b-td>
                    <b-td style="padding-left:20px">
                      <ValidationProvider name="Physical" vid="physical" rules="required">
                            <b-form-group v-slot="{ physical }">
                              <b-form-radio v-model="admisson_other_info.physical" :aria-describedby="physical" name="physical" value="1">{{$t('social_service.yes')}}</b-form-radio>
                              <b-form-radio v-model="admisson_other_info.physical" :aria-describedby="physical" name="physical" value="2">{{$t('social_service.no')}}</b-form-radio>
                            </b-form-group>
                        </ValidationProvider>
                    </b-td>
                    <b-td style="padding-left:20px">
                      <ValidationProvider name="Physical Comment (Bn)" vid="physical_comment_bn" rules="required">
                          <b-form-group class="" label-for="physical_comment_bn" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_bn')}}
                            <b-form-textarea id="physical_comment_bn" v-model="admisson_other_info.physical_comment_bn"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                      <ValidationProvider name="Physical Comment (En)" vid="physical_comment" rules="required">
                          <b-form-group class="" label-for="physical_comment" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_en')}}
                            <b-form-textarea id="physical_comment" v-model="admisson_other_info.physical_comment"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td class="w-25">
                      {{$t('social_service.tak_med_adv')}}
                    </b-td>
                    <b-td style="padding-left:20px">
                      <ValidationProvider name="Medicine" vid="medicine" rules="required">
                            <b-form-group v-slot="{ medicine }">
                              <b-form-radio v-model="admisson_other_info.medicine" :aria-describedby="medicine" name="medicine" value="1">{{$t('social_service.yes')}}</b-form-radio>
                              <b-form-radio v-model="admisson_other_info.medicine" :aria-describedby="medicine" name="medicine" value="2">{{$t('social_service.no')}}</b-form-radio>
                            </b-form-group>
                        </ValidationProvider>
                    </b-td>
                     <b-td style="padding-left:20px">
                      <ValidationProvider name="Medicine Comment (Bn)" vid="medicine_comment_bn" rules="required">
                          <b-form-group class="" label-for="medicine_comment_bn" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_bn')}}
                            <b-form-textarea id="medicine_comment_bn" v-model="admisson_other_info.medicine_comment_bn"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                      <ValidationProvider name="Medicine Comment (En)" vid="medicine_comment" rules="required">
                          <b-form-group class="" label-for="medicine_comment" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_en')}}
                            <b-form-textarea id="medicine_comment" v-model="admisson_other_info.medicine_comment"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td class="w-25">
                      {{$t('social_service.other_dises')}}
                    </b-td>
                    <b-td style="padding-left:20px">
                      <ValidationProvider name="Other Disease" vid="other_disease" rules="required">
                            <b-form-group v-slot="{ other_disease }">
                              <b-form-radio v-model="admisson_other_info.other_disease" :aria-describedby="other_disease" name="other_disease" value="1">{{$t('social_service.yes')}}</b-form-radio>
                              <b-form-radio v-model="admisson_other_info.other_disease" :aria-describedby="other_disease" name="other_disease" value="2">{{$t('social_service.no')}}</b-form-radio>
                            </b-form-group>
                        </ValidationProvider>
                    </b-td>
                     <b-td style="padding-left:20px">
                      <ValidationProvider name="Other Disease Comment (Bn)" vid="other_disease_comment_bn" rules="required">
                          <b-form-group class="" label-for="other_disease_comment_bn" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_bn')}}
                            <b-form-textarea id="other_disease_comment_bn" v-model="admisson_other_info.other_disease_comment_bn"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                      <ValidationProvider name="Other Disease Comment (En)" vid="other_disease_comment" rules="required">
                          <b-form-group class="" label-for="other_disease_comment" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_en')}}
                            <b-form-textarea id="other_disease_comment" v-model="admisson_other_info.other_disease_comment"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-td class="w-25">
                      {{$t('social_service.familly_his_dis')}}
                    </b-td>
                    <b-td style="padding-left:20px">
                      <ValidationProvider name="Family History" vid="family_history" rules="required">
                            <b-form-group v-slot="{ family_history }">
                              <b-form-radio v-model="admisson_other_info.family_history" :aria-describedby="family_history" name="family_history" value="1">{{$t('social_service.yes')}}</b-form-radio>
                              <b-form-radio v-model="admisson_other_info.family_history" :aria-describedby="family_history" name="family_history" value="2">{{$t('social_service.no')}}</b-form-radio>
                            </b-form-group>
                        </ValidationProvider>
                    </b-td>
                     <b-td style="padding-left:20px">
                      <ValidationProvider name="Family History Comment (Bn)" vid="family_history_comment_bn" rules="required">
                          <b-form-group class="" label-for="family_history_comment_bn" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_bn')}}
                            <b-form-textarea id="family_history_comment_bn" v-model="admisson_other_info.family_history_comment_bn"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                      <ValidationProvider name="Family History Comment (En)" vid="family_history_comment" rules="required">
                          <b-form-group class="" label-for="family_history_comment" slot-scope="{ valid, errors }">
                            {{$t('social_service.coment_en')}}
                            <b-form-textarea id="family_history_comment" v-model="admisson_other_info.family_history_comment"
                            rows="3"
                            max-rows="3"
                            :state="errors[0] ? false : (valid ? true : null)"></b-form-textarea>
                            <div class="invalid-feedback">
                              {{ errors[0] }}
                            </div>
                          </b-form-group>
                      </ValidationProvider>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>
            </b-form>
          </ValidationObserver>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { AdmissionOtherFormCaseHistory, caseHistoryUploadFileApi, caseHistoryDeleteFileApi, caseHistoryDeleteDocApi } from '../../../api/routes'
// import StaticData from './static_data.js'

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: ['admisson_other_info', 'patient_form'],
  data () {
    return {
      hospitalServiceBaseUrl: hospitalServiceBaseUrl,
      hostWardList: [],
      bedList: [],
      attachment_two: '',
      // Handling (Add More) File Upload
      customAttachment: {
        document_title: null,
        document_title_bn: null,
        attachment: [],
        loader: false
      },
      rows: []
    }
  },
  mounted () {
    core.index()
  },
  watch: {
    'patient_form.department_id': function (newVal, oldVal) {
      if (newVal !== '0' && oldVal !== '0') {
          this.patient_form.hos_ward_id = 0
          this.patient_form.hos_bed_id = 0
        }
        this.hostWardList = this.gethosWardListByDepartment(parseInt(newVal))
    },
    'patient_form.hos_ward_id': function (newVal, oldVal) {
      if (newVal && oldVal !== '0') {
          this.patient_form.hos_bed_id = 0
        }
        this.bedList = this.getBedListByWard(parseInt(newVal))
    }
  },
  computed: {
    departmentList: function () {
      return this.$store.state.HospitalDisabilityService.commonObj.deptList.filter(item => item.status === 1)
    }
  },
  methods: {
    async onFileChange (e) {
      this.attachment_two = e.target.files[0]
      if (!this.validateFileUploadAssciatedFields()) {
        return
      }
      this.customAttachment.loader = true
      const config = {
          headers: { 'content-type': 'multipart/form-data' }
      }
      var formData = new FormData()
      formData.append('custom_file', e.target.files[0])

      const result = await RestApi.postData(hospitalServiceBaseUrl, caseHistoryUploadFileApi, formData, config)
      if (result.success) {
          this.admisson_other_info.related_documents.push({
            id: 0, // id - 0 signifies that file is uploaded but DB Record is not created yet
            original_file_name: result.data.originalFileName,
            file_name: result.data.fileFullPath,
            document_title: this.customAttachment.document_title,
            document_title_bn: this.customAttachment.document_title_bn
          })
          this.customAttachment = Object.assign({}, {
            document_title: null,
            document_title_bn: null,
            attachment: [],
            loader: false
          })
      } else {
        // From Back End get error in custom_file & assign to attachemnt on the frontend
        const errors = { attachment: [result.errors.custom_file] }
        this.$refs.form.setErrors(errors)
      }
    },
    validateFileUploadAssciatedFields () {
        let errors = {}
        if (this.customAttachment.document_title === null || this.customAttachment.document_title === '') {
            errors = Object.assign({}, errors, { document_title: ['Document Tile field is required'] })
        }
        if (this.customAttachment.document_title_bn === null || this.customAttachment.document_title_bn === '') {
            errors = Object.assign({}, errors, { document_title_bn: ['Document Tile (Bn) field is required'] })
        }
        if (Object.keys(errors).length > 0) {
            this.$refs.form.setErrors(errors)
            this.customAttachment.attachment = []
            return false
        }
        return true
    },
    validateFileUploadArrayLength () {
      // Validating length of array when form is submitted, ensuring at least on attachment is uploaded.
      if (this.admisson_other_info.related_documents.length <= 0) {
        const errors = {
          document_title: ['Document Tile field is required'],
          document_title_bn: ['Document Tile (Bn) field is required'],
          attachment: ['An Attachment is required']
        }
        this.$refs.form.setErrors(errors)
        return false
      }
      return true
    },
    async deleteUploadedFile (fileName) {
        this.customAttachment.loader = true
        const result = await RestApi.deleteData(hospitalServiceBaseUrl, caseHistoryDeleteFileApi, { file_name: fileName })
        this.customAttachment.loader = false
        if (!result.success) {
            this.$toast.error({
                title: 'Error',
                message: 'Failed to delete file. Please, try again.'
            })
            return
        }
        const tmp = this.admisson_other_info.related_documents.filter(item => {
            return item.file_name !== fileName
        })
        this.admisson_other_info.related_documents = tmp
    },
    async deleteUploadedFileFromDatabase (file) {
      this.customAttachment.loader = true
      const result = await RestApi.deleteData(hospitalServiceBaseUrl, `${caseHistoryDeleteDocApi}/${file.id}`)
      this.customAttachment.loader = false
      if (!result.success) {
        this.customAttachment.loader = false
          this.$toast.error({
              title: 'Error',
              message: 'Failed to delete file. Please, try again.'
          })
          return
      }
      const tmp = this.admisson_other_info.related_documents.filter(item => {
          return item.id !== file.id
      })
      this.admisson_other_info.related_documents = tmp
    },
    async admission_submit () {
      // var result = await RestApi.postData(hospitalServiceBaseUrl, AdmissionOtherFormCaseHistory, this.admisson_other_info)
      this.admisson_other_info.case_main_id = parseInt(this.$route.params.case_id) > 0 ? parseInt(this.$route.params.case_id) : 0
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadingState = { loading: false, listReload: false }
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      // this.patient_registration.patient_acknowledgement = JSON.stringify(this.patient_registration.patient_acknowledgement)
      var formData = new FormData()
      Object.keys(this.patient_form).map(key => {
          if (key === 'attachment') {
            formData.append('attachment', this.attachment_two)
          } else {
            formData.append(key, this.patient_form[key])
          }
      })
      formData.append('admisson_other_info', JSON.stringify(this.admisson_other_info))
        formData.append('_method', 'PUT')

        result = await RestApi.postData(hospitalServiceBaseUrl, AdmissionOtherFormCaseHistory, formData, config)

      loadingState.listReload = true
      this.$store.dispatch('mutateCommonProperties', loadingState)
      if (result.success) {
        this.$store.commit('HospitalDisabilityService/mutateCommonObj', { hasDropdownLoaded: false })
          this.$toast.success({
            title: 'Success',
            message: this.$t('globalTrans.save_msg'),
            color: '#D6E09B'
          })
          return result
          } else {
            this.$toast.error({
                title: 'Error',
                message: this.$t('globalTrans.form_error_msg'),
                color: '#D6E09B'
            })
            this.$refs.form.setErrors(result.errors)
          }
    },
    gethosWardListByDepartment (deptId) {
        const objectData = this.$store.state.HospitalDisabilityService.commonObj.hosWardList
        if (this.patient_form.hospital_id !== '0') {
          const wardObjectList = objectData.filter(item => item.department_id === deptId && item.hospital_id === this.patient_form.hospital_id)
        return wardObjectList.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
        }
    },
    getBedListByWard (wardId) {
        const objectData = this.$store.state.HospitalDisabilityService.commonObj.hosBedList
        const wardObjectList = objectData.filter(item => item.department_id === this.patient_form.department_id && item.ward_id === wardId)
        return wardObjectList.map((obj, key) => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    }
  }
}
</script>
<style scoped>
textarea{
  width: 95%;
}
</style>
